import React, { useContext, useEffect, useState } from 'react';

import { LIVE_CLASSROOM_TEACHERS_DOMAIN } from 'utils/constants';
import { useMixpanelPageOpenTrack } from 'utils/integrations/mixpanel';
import { trackMixpanelPageView } from 'utils/integrations/mixpanel';

import AcceleratedCurriculumSwitch from './components/AcceleratedCurriculumSwitch';
import AssignmentCreateSelectFlow from './components/AssignmentCreateSelectFlow';
import SubjectSelect from './components/SubjectSelect';
import CurriculumIndex from 'components/CurriculumIndex';
import UserContext from 'components/UserContext';

import styles from './styles.module.scss';

const LIVE_CLASSROOM_ENABLED =
  process.env.REACT_APP_LIVE_CLASSROOM_ENABLED === 'true';

const TeacherAssignmentCreate = () => {
  const [isFlowSelected, setIsFlowSelected] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [isCreateTemplateSelected, setIsCreateTemplateSelected] =
    useState(false);

  const [isAcceleratedCurriculum, setIsAcceleratedCurriculum] = useState(false);

  const { user } = useContext(UserContext);

  useEffect(() => {
    trackMixpanelPageView(user.id, {
      feature: 'create',
      view: 'type'
    });
  }, [user]);

  useEffect(() => {
    if (
      (user?.is_live_classroom_teacher ||
        LIVE_CLASSROOM_TEACHERS_DOMAIN.includes(user.email.split('@')[1])) &&
      LIVE_CLASSROOM_ENABLED
    ) {
      setSelectedSubject('math');
    }
  }, [user]);

  useMixpanelPageOpenTrack('Teacher opened Create page');

  const showStepper = selectedSubject !== null;

  return (
    <div className={styles.container}>
      {isFlowSelected && isCreateTemplateSelected && (
        <div className={styles.buttonContainer}>
          <button
            type="button"
            className={styles.backButton}
            onClick={() => {
              setIsFlowSelected(false);
              setIsCreateTemplateSelected(false);
            }}
          >
            ← BACK: CHOOSE TYPE
          </button>
        </div>
      )}

      {showStepper && (
        <div className={styles.navTabs}>
          <button type="button" className={`${styles.tab} ${styles.active}`}>
            Choose type
          </button>
          <button
            type="button"
            className={`${styles.tab} ${styles.tabProgress}`}
          >
            Create
          </button>
          {selectedSubject === 'math' && !isCreateTemplateSelected && (
            <button
              type="button"
              className={`${styles.tab} ${styles.tabProgress}`}
            >
              Confirm
            </button>
          )}
          <button
            type="button"
            className={`${styles.tab} ${styles.tabProgress}`}
          >
            Assign
          </button>
        </div>
      )}

      {!selectedSubject && <SubjectSelect selectSubject={setSelectedSubject} />}

      {!isFlowSelected && selectedSubject && (
        <AssignmentCreateSelectFlow
          setIsFlowSelected={setIsFlowSelected}
          setIsCreateTemplateSelected={setIsCreateTemplateSelected}
          isMathAssignment={
            selectedSubject === 'math' || selectedSubject === null
          }
        />
      )}

      {isFlowSelected && isCreateTemplateSelected && (
        <>
          <AcceleratedCurriculumSwitch
            isAcceleratedCurriculum={isAcceleratedCurriculum}
            setIsAcceleratedCurriculum={setIsAcceleratedCurriculum}
          />
          <CurriculumIndex isAcceleratedCurriculum={isAcceleratedCurriculum} />
        </>
      )}
    </div>
  );
};

export default TeacherAssignmentCreate;
